import {observable, action} from 'mobx';
import _ from 'lodash';
class Alert {

  @observable event = {};

  @action success = (text,time ) => {
    this.event = _.assign({text: text, type: 'success',time: time})
  };

  @action error = text => {
    this.event = _.assign({text: text, type: 'error'})
  };

  @action info = text => {
    this.event = _.assign({text: text, type: 'info'})
  };

}

export default new Alert();



// WEBPACK FOOTER //
// ./src/stores/Alert.js